module.exports = __webpack_public_path__ + "img/use-a-new-template.9e92a8c.png";